<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :url="url"
      :title="$lang.searchUser"
      :remove_item="remove_item"
      config="user"
      :toggleable="true"
      :showSomeBtn="true"
      :allowRemove="false"
      addModalSize="lg"
      :isLoading="loadingItem"
      ref="userSearch"
      :hiddenFields="hiddenFields"
      :dynamicButtons="buttons"
      primaryKey="code"
      :allowFields="$lang.search_user_fildes"
      :openNewTab="true"
      routeName="editUser"
      :filterCatch="true"
      :extraButtons="extraButtons"
      @getPermisson="getPermissions"
      :visibleAdd="false"
    >
      <template slot="addModal" slot-scope="search">
        <addUser isModal @modal-end-up="search.close"></addUser>
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="showRoleModal"
      :title="assignRoleModalTitle"
      size="lg"
      :hide-footer="!currentParvandeh || showChangeRole"
      @close="cancelRole"
      @hidden="currentParvandeh = null"
    >
      <b-overlay :show="roleLoading" rounded="sm" :opacity="0.7">
        <RegistrationSelect
          v-if="!currentParvandeh && showRoleModal"
          :userItem="selected_user"
          @updateCurrentParvandeh="updateCurrentParvandeh"
        />
        <div v-if="currentParvandeh">
          <b-alert show variant="warning">
            <b-row>
              <b-col cols="12" md="">
                <i class="fas fa-info-circle mr-2" />
                <span v-html="userParvandehAssignRoleTitle" />
              </b-col>
              <b-col cols="12" md="auto">
                <b-button
                  @click="currentParvandeh = null"
                  variant="outline-primary"
                  class="ml-3"
                >
                  {{ $lang.parvandehChange }}
                </b-button>
              </b-col>
            </b-row>
          </b-alert>
          <ChangeRoleList
            v-if="showChangeRole"
            :parvandehCode="pathOr(null, ['code'], currentParvandeh)"
          />
          <TreePage
            v-else
            :showRoleSelected="true"
            :tags="roleSelected"
            @updateRoleSelected="updateRoleSelected"
          />
        </div>
      </b-overlay>
      <template v-slot:modal-footer>
        <b-button variant="success" @click="assignRole" :disabled="roleLoading">
          <span>
            {{ $lang.submitButton }}
            <i class="fa fa-check"></i>
          </span>
        </b-button>
        <b-button variant="danger" @click="cancelRole" v-if="!roleLoading">
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="isShowkey"
      :title="$lang.add_user_role_tooltip"
      size="md"
      hide-header
      hide-footer
    >
      <changePassForm
        @submit="saveChangePass"
        @cancel="cancelChangePass"
        :item="itemChangePass"
      />
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="isShowUserSecret"
      :title="$lang.temporary_password"
      size="md"
      hide-footer
    >
      <b-alert class="text-justify" variant="success" show>
        <strong v-html="$lang.titleUserSecret"> </strong>
      </b-alert>

      <p class="text-center mb-1">
        <b>{{ $lang.username }}</b>
      </p>
      <h3 class="text-center" dir="ltr" ref="username">
        <b> {{ username }} </b>
        <b-button
          class="text-center"
          variant="info"
          size="sm"
          @click="ClipboardUserName(username)"
          ><i class="fas fa-clipboard text-white"></i
        ></b-button>
      </h3>
      <p class="text-center mb-1">
        <b>{{ $lang.password_temp }}</b>
      </p>
      <h3 class="text-center" dir="ltr" ref="userSecretPassword">
        <b> {{ UserSecretResult && UserSecretResult.password_temp }} </b>
        <b-button
          class="text-center"
          variant="info"
          size="sm"
          @click="Clipboard(UserSecretResult.password_temp)"
          ><i class="fas fa-clipboard text-white"></i
        ></b-button>
      </h3>

      <p class="text-center">
        <b
          >{{ $lang.expire_time_minute }}:
          {{ UserSecretResult && UserSecretResult.expire_second }}
          {{ $lang.second }}</b
        >
      </p>
    </b-modal>
    <Confirm
      v-model="enableConfirm"
      :title="$lang.change_user_state"
      :description="enableConfirmDescription"
      dynamicClass=""
      :loading="enableConfirmLoading"
      :loadingSpinnerText="$lang.updating_data"
      :preventDefault="true"
      :cancel-title="$lang.no"
      :ok-title="$lang.yes"
      @cancel="cancelEnableConfirm"
      @ok="okEnableConfirm"
    />
    <Confirm
      v-model="usersTwoStepChangeConfirm"
      :title="usersTwoStepChangeConfirmTitle"
      :description="usersTwoStepChangeConfirmDescription"
      :loading="usersTwoStepChangeConfirmLoading"
      :loadingSpinnerText="$lang.sending_data"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @cancel="usersTwoStepChangeConfirm = false"
      @ok="setUsersTwoStepChange"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import config from "@/shared/config";
import AddUser from "./addUser";
import TreePage from "@/components/tree/treePage";
import changePassForm from "./../forms/changePassForm";
import RegistrationSelect from "./registrationSelect.vue";
import ChangeRoleList from "./ChangeRoleList.vue";
import Confirm from "@/components/base/confirm";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { generateApiUrl, generateStoreGetters, isAdmin } from "@/shared/utils";

export default {
  name: "search-user",
  validations: {
    roleSelected: {
      required,
    },
  },
  components: {
    AddUser,
    Search,
    TreePage,
    changePassForm,
    Confirm,
    RegistrationSelect,
    ChangeRoleList,
  },
  data() {
    return {
      hiddenFields: [
        "email",
        "created_at.jalali",
        "created_by",
        "updated_by",
        "updated_at",
      ],
      loadingItem: false,
      url: this.$config.api_url + this.$config.resources.user,
      selected_user: null,
      showRoleModal: false,
      roleLoading: false,
      isShowUserSecret: false,
      role_options: [],
      isShowkey: false,
      itemChangePass: {},
      roleSelected: [],
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "2",
          name: "enable",
          click: this.showEnableConfirm,
        },
        /* {
          id: "5",
          name: "key",
          click: this.showchangePass
        }, */
        {
          id: "6",
          name: "userRole",
          text: this.$lang.definition_show_change_role,
          click: this.showRoles,
        },
        /* {
          id: "6",
          name: "userSecret",
          click: this.userSecretPassword
        } */
      ],
      selected_labels: [],
      userRole: [],
      usersTwoStepChangeState: 1,
      usersTwoStepChangeConfirm: false,
      usersTwoStepChangeConfirmTitle: "",
      usersTwoStepChangeConfirmDescription: "",
      UserSecretResult: {},
      username: null,
      currentParvandeh: null,
      usersTwoStepChangeConfirmLoading: false,
      showChangeRole: false,
      enableConfirm: false,
      enableConfirmLoading: false,
      enableConfirmItem: null,
      permissions: [],
    };
  },
  computed: {
    userParvandehAssignRoleTitle() {
      const licenseCaption = pathOr(
        "",
        ["license", "caption"],
        this.currentParvandeh
      );
      const parvandehNumber = pathOr(
        "",
        ["parvandeh_number"],
        this.currentParvandeh
      );
      const term = pathOr("", ["term", "caption"], this.currentParvandeh);
      const roles = this.generateRoles(this.currentParvandeh, " - ");
      const rolesTitle = roles.length > 1 ? "نقش‌ها" : "نقش";
      const firstPartTitle = `پرونده شماره <b>${parvandehNumber}</b> - ${term}`;
      const title = licenseCaption
        ? firstPartTitle
        : `${firstPartTitle}<br><small><b class="ml-4">${rolesTitle}:</b> ${roles}</small>`;

      return this.$lang.userParvandehAssignRole.replace("{0}", title);
    },
    assignRoleModalTitle() {
      const user = pathOr("", ["person", "name"], this.selected_user);
      return `${this.$lang.definition_show_change_role} ${user}`;
    },
    enableConfirmDescription() {
      const is_enable = pathOr(null, ["is_enable"], this.enableConfirmItem);
      return is_enable
        ? `با غیر فعال سازی کاربری فرد دسترسی ورود کاربر به سامانه و انجام هرگونه فعالیت گرفته می شود.
      <br><br><strong>آیا از برای غیر فعال سازی کاربری مطمئن هستید ؟</strong>`
        : `با فعال سازی کاربری فرد دسترسی ورود کاربر به سامانه و کلیه پرونده‌های فعال و انجام هرگونه فعالیت بازمی شود.
      <br><br><strong>آیا از برای فعال سازی کاربری مطمئن هستید ؟</strong>`;
    },
    extraButtons() {
      return [
        {
          name: "active_two_step_verification_option_for_all",
          condition: includes("modir_system", this.roles),
          title: this.$lang.active_two_step_verification_option_for_all,
          click: this.showActiveUsersTwoStepChangeConfirm,
          iconName: "cellphone-check",
        },
        {
          name: "deactive_two_step_verification_option_for_all",
          condition: includes("modir_system", this.roles),
          title: this.$lang.deactive_two_step_verification_option_for_all,
          click: this.showDeActiveUsersTwoStepChangeConfirm,
          iconName: "cellphone-remove",
        },
      ];
    },
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    isAdmin,
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    Clipboard(text) {
      navigator.clipboard.writeText(text);
      this.selectText(this.$refs.userSecretPassword);
      document.execCommand("copy");
      this.$notify.success(this.$lang.linkCopy);
    },
    ClipboardUserName(text) {
      navigator.clipboard.writeText(text);
      this.selectText(this.$refs.username);
      document.execCommand("copy");
      this.$notify.success(this.$lang.linkCopy);
    },
    async userSecretPassword(item) {
      try {
        let url =
          this.$config.api_url +
          this.$config.profile.user_code_generate_temp_password.replace(
            "{0}",
            item.code
          );
        const result = await this.$httpService.patch(url);
        this.UserSecretResult = result.data.data;
        this.username = item.national_code;
        this.isShowUserSecret = true;
      } catch (error) {
        this.$generateError(error);
      }
    },
    async saveChangePass(payload) {
      try {
        let url =
          this.$config.api_url +
          this.$config.resources.user_change_pass.replace(
            "{0}",
            this.itemChangePass.code
          );
        const result = await this.$httpService.patch(url, payload);
        this.$notify.success(result.data.message);
        this.isShowkey = false;
      } catch (error) {
        this.$generateError(error);
      }
    },
    cancelChangePass() {
      this.isShowkey = false;
    },
    showchangePass(item) {
      this.itemChangePass = item;
      this.isShowkey = true;
    },
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.code)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    showRoles(item) {
      this.showRoleModal = true;
      this.selected_user = item;
    },
    assignRole() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }
      this.roleLoading = true;

      let selected = this.roleSelected.map((x) => x.code);
      const parvandeh_code = pathOr(null, ["code"], this.currentParvandeh);
      let payload = {
        role: selected,
        parvandeh_code,
      };
      let user_role = config.resources.user_role.replace(
        "{}",
        this.selected_user.code
      );
      this.$httpService
        .put(config.api_url + user_role, payload)
        .then((response) => {
          this.$notify.success(response.data.message);
          this.showRoleModal = false;
          this.roleSelected = null;
          this.selected_user = null;
          this.getData();
        })
        .catch((error) => {
          this.$generateError(error);
        })
        .finally(() => {
          this.roleLoading = false;
        });
    },
    cancelRole() {
      this.roleSelected = null;
      this.selected_user = null;
      this.showRoleModal = false;
      this.currentParvandeh = null;
    },
    showActiveUsersTwoStepChangeConfirm(active = true) {
      this.usersTwoStepChangeState = (active && 1) || 0;
      this.usersTwoStepChangeConfirm = true;
      this.usersTwoStepChangeConfirmTitle =
        (active &&
          this.$lang
            .active_two_step_verification_option_for_all_confirm_title) ||
        this.$lang.deactive_two_step_verification_option_for_all_confirm_title;
      this.usersTwoStepChangeConfirmDescription =
        (active &&
          this.$lang.two_step_verification_option_for_all_confirm_descriptin.replace(
            "{var}",
            "فعال‌سازی"
          )) ||
        this.$lang.two_step_verification_option_for_all_confirm_descriptin.replace(
          "{var}",
          "غیر‌فعال‌سازی"
        );
    },
    showDeActiveUsersTwoStepChangeConfirm() {
      this.showActiveUsersTwoStepChangeConfirm(false);
    },
    async setUsersTwoStepChange() {
      try {
        this.usersTwoStepChangeConfirmLoading = true;
        const url =
          this.$config.api_url + this.$config.resources.users_two_step_change;
        const payload = {
          config_value: {
            status: this.usersTwoStepChangeState,
          },
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.usersTwoStepChangeConfirm = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.usersTwoStepChangeConfirmLoading = false;
      }
    },
    generateRoleSelected(data) {
      const roles = pathOr([], ["role_object"], data);
      this.roleSelected = roles.map((x) => {
        return {
          code: x.code,
          caption: x.name,
        };
      });
    },
    async updateCurrentParvandeh(item, showChangeRole = false) {
      this.showChangeRole = showChangeRole;
      this.currentParvandeh = item;
      this.generateRoleSelected(item);
    },
    generateRoles(data, splitter) {
      return pathOr([], ["role_object"], data)
        .map((x) => x.name)
        .join(splitter);
    },
    updateRoleSelected(data) {
      this.roleSelected = data;
    },
    getData() {
      this.$refs.userSearch.getItems();
    },
    showEnableConfirm(item) {
      this.enableConfirmItem = item;
      this.enableConfirm = true;
    },
    cancelEnableConfirm() {
      this.enableConfirmItem = null;
      this.enableConfirm = false;
    },
    async okEnableConfirm() {
      try {
        this.enableConfirmLoading = true;
        const { code, is_enable } = this.enableConfirmItem;
        const url = generateApiUrl(["resources", "user_id"], [code]);
        const payload = { is_enable: is_enable ? 0 : 1 };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.cancelEnableConfirm();
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.enableConfirmLoading = false;
      }
    },
    getPermissions(permissions) {
      this.permissions = permissions;
    },
  },
};
</script>
